import { flip, autoPlacement } from '@floating-ui/react';
export function getFloatingPlacement(placement) {
    switch (placement) {
        case 'auto':
            return [undefined, autoPlacement()];
        case 'auto-end':
            return [
                undefined,
                autoPlacement({
                    allowedPlacements: ['top-end', 'bottom-end', 'left-end', 'right-end'],
                }),
            ];
        case 'auto-start':
            return [
                undefined,
                autoPlacement({
                    allowedPlacements: ['top-start', 'bottom-start', 'left-start', 'right-start'],
                }),
            ];
        case 'top':
        case 'bottom':
        case 'right':
        case 'left':
        case 'top-start':
        case 'top-end':
        case 'bottom-start':
        case 'bottom-end':
        case 'right-start':
        case 'right-end':
        case 'left-start':
        case 'left-end':
            return [
                placement,
                flip({
                    mainAxis: true,
                    crossAxis: true,
                    fallbackAxisSideDirection: 'start',
                }),
            ];
        default:
            // @ts-expect-error - when all cases covered
            return null;
    }
}
